import {
  DateRangeFilter,
  type PeriodFilterProps,
} from '@/components/date-range-filter';
import { PeriodChips } from '@/components/period/period-chips';
import { useIsMobile } from '@/hooks/use-mobile';

export type { PeriodFilterProps };

/**
 * Period filter for every screen (AD-020): chips below 768px, the current
 * `DateRangeFilter` popover from 768px up, with the same props.
 */
export function PeriodFilter(props: PeriodFilterProps) {
  const isMobile = useIsMobile();
  return isMobile ? <PeriodChips {...props} /> : <DateRangeFilter {...props} />;
}
